import Stack from '@mui/material/Stack';
import { useSelector } from 'react-redux';

import { hasPermissionByIds } from '@gef-ui/cdu-user/selectors';

import { codelistProvider } from 'components';
import { codelists } from 'constants/codelists';
import { MPU_DISPLAY_LEAD_LIST } from 'features/common/acl/constants';
import { getTaskTypesAndLeadTypes } from 'features/views/settings/selectors';
import { getContextUser, hasContextPermissionById } from 'features/views/userContext/selectors';

import InformationSettings from './InformationSettings';
import LeadsSettings from './LeadsSettings';
import TasksSettings from './TasksSettings';

export const InformationCreationTab = () => {
	const contextUser = useSelector(getContextUser);

	const userShowLeadListPerm = useSelector((state) => hasPermissionByIds(state)(MPU_DISPLAY_LEAD_LIST));
	const contextUserShowLeadListPerm = useSelector((state) => hasContextPermissionById(state, MPU_DISPLAY_LEAD_LIST));
	const hasShowLeadListPermission = contextUser ? contextUserShowLeadListPerm : userShowLeadListPerm;

	const { tasks, leads } = useSelector(getTaskTypesAndLeadTypes);

	return (
		<Stack spacing={3}>
			<TasksSettings tasks={tasks} />
			{hasShowLeadListPermission && <LeadsSettings leads={leads} />}
			<InformationSettings />
		</Stack>
	);
};

export default codelistProvider(codelists.taskSubtypes)(InformationCreationTab);
